import { styled } from '@mui/material';

export const SearchJobsWithWhatsappWrapper = styled('div')`
  padding: 20px;
  background-color: #f9f9f9;
  background: linear-gradient(135deg, #25d366, #00843f);
  color: white;
  padding: 1.5rem;
  margin: 1rem 1.5rem;
  border-radius: 5px;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);

  animation: 2s ease-in-out 0s 3 normal none running pulse;
  &:before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent,
      rgba(255, 255, 255, 0.1),
      transparent
    );
    animation: shine 3s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 4px 15px rgba(37, 211, 102, 0.4);
    }
    50% {
      transform: scale(1.05);
      box-shadow: 0 6px 20px rgba(37, 211, 102, 0.6);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 4px 15px rgba(37, 211, 102, 0.4);
    }
  }

  @keyframes shine {
    0% {
      transform: translateX(-100%) translateY(-100%) rotate(45deg);
    }
    100% {
      transform: translateX(100%) translateY(100%) rotate(45deg);
    }
  }
`;

export const HightlightedText = styled('div')`
  background: rgba(255, 255, 255, 0.2);
  padding: 0.4rem 0.8rem;
  border-radius: 5px;
  font-size: 0.9rem;
  margin-bottom: 0.8rem;
  display: inline-block;
`;
